// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"style_titleIcon__34rRm"};